function ticketPrioridad(codigo){
    let valor = "";
    switch (codigo) {  //0=BAJA, 1=MEDIA, 2=ALTA, 3=CRITICA
        case 1: {
            valor = "MEDIA"
            break;
        }
        case 2: {
            valor = "ALTA"
            break;
        }
        case 3: {
            valor = "CRITICA"
            break;
        }
        default: {
            valor = "BAJA"
            break;
        }
    }
    return valor    
}

function ticketEstado(codigo){
    let valor = "";
    switch (codigo) {  //0=INICIADO, 1=EN PROCESO, 2=RESUELTO, 3=CERRADO
        case 1: {
            valor = "EN PROCESO"
            break;
        }
        case 2: {
            valor = "RESUELTO"
            break;
        }
        case 3: {
            valor = "CERRADO"
            break;
        }
        default: {
            valor = "INICIADO"
            break;
        }
    }
    return valor    
}


export {
    ticketPrioridad,
    ticketEstado,
}